import { useContext, useEffect } from "react";
import { useState } from "react";
import { createContext } from "react"
import { Header } from "../componentes/layout/template/Header";
import { ViewGerencia } from "../componentes/layout/view/ViewGerencia";
import packageJson from '../../package.json'
import { useSistema } from "./useSistema";

const viewHome = {
    chave: 'home',
    icone: 'home',
    nome: 'Dashboard',
    titulo: (process.env.REACT_APP_NOME_SISTEMA ?? 'AnT Sistema') + ' v' + packageJson.version,
    fechar: false,
    ativo: true, 
    parametros: {},
}

const ViewContext = createContext({})

export function ViewProvider({children}) {
    const { usuario } = useSistema()
    const [views, setViews] = useState([viewHome])

    function mudaView(chave) {
        setViews((views) => {
                return views.map(f => {
                    if (f.chave === chave)
                        return { ...f, ativo: true }
                    else
                        return { ...f, ativo: false }
                })
            }
        )
    }

    function limpaViews(){
        setViews([viewHome])
    }

    function addView(view) {
        const indice = views.findIndex((f) => f.chave === view.chave)
        
        if(indice <= 0){
            setViews([
                ...views, 
                {
                    ...view, 
                    ativo: false,
                    permissoes: view.submenu?.filter(p => p.acao)?.map(p => p.chave)
                }
            ])
        }

        mudaView(view.chave)
    }

    function removeView(chave) {
        const lista = views.filter((f) => f.chave !== chave)

        setViews(lista)
        mudaView(lista[lista.length - 1].chave)
    }

    function checkView(chave) {
        const indice = views.findIndex((f) => f.chave === chave)
        
        return (indice > 0)
    }

    function limpaParametrosView(chave){
        setViews((views) => {
            return views.map(f => {
                if (f.chave === chave)
                    return { ...f, parametros: {} }
                else
                    return f
            })
        })
    }

    function checkPermissao(chave, permissao){
        return views.find(f => f.chave === chave)?.permissoes?.includes(permissao)
    }

    function getParametrosView(chave){
        return views.find(f => f.chave === chave)?.parametros
    }

    useEffect(() => {
        limpaViews()
    }, [usuario.empresa])

    return (
      <ViewContext.Provider value={{ 
        views, 
        mudaView, 
        limpaViews, 
        addView, 
        removeView, 
        checkView,
        limpaParametrosView,
        checkPermissao,
        getParametrosView
      }}>
        <Header />
        <ViewGerencia />
        {children}
      </ViewContext.Provider>
    )
}

export function useViewSistema() {
    const context = useContext(ViewContext)

    return context;
}